/*
 * Configuration du mode « dry-run » de l'écran /dispatch (lecture seule).
 *
 * Quand une source distante est active (preprod / prod, via le tunnel), l'appel loadstate est enrichi
 * de `&source=...&day=...` : l'écran /dispatch natif s'affiche alors avec la data de cette source, sans
 * rien écrire (routage read-replica côté API). Source par défaut = `local` (comportement normal).
 *
 * Vit dans un module dédié (et non le store Redux) car c'est une config transverse de requête, lue par
 * la saga loadDispatch à chaque rechargement — y compris le rechargement périodique.
 */
const _config = { source: "local", day: "" };

export function getDryRun() {
  return _config;
}

export function setDryRun(patch) {
  Object.assign(_config, patch);
}

export function isDryRunActive() {
  return _config.source && _config.source !== "local";
}

// Paramètres de requête à ajouter à loadstate selon la config courante (chaîne vide si inactif).
export function dryRunQueryParams() {
  if (!isDryRunActive()) {
    return "";
  }
  let params = `&source=${encodeURIComponent(_config.source)}`;
  if (_config.day) {
    params += `&day=${encodeURIComponent(_config.day)}`;
  }
  return params;
}
